import { parseToItems } from 'utils/parseToItems';

import useTranslation from 'components/fields/FieldSelectPanelField/hooks/useTranslation';

import useFields from 'hooks/useFields';
import useSelectPanelField from 'hooks/useSelectPanelField';

import { DEFAULT_PAGE_SIZE } from './constants';
import type { SiteResponse } from './types';

const useData = (farmId?: string) => {
    const { fetch, isLoading, reset } = useFields();
    const { NO_FIELDS_FOUND, SELECT_A_FARM_TO_SEE_FIELDS } = useTranslation();

    const fetchWithFarmId = (args?: { name?: string; pageSize?: number }) =>
        fetch({
            farmId,
            name: args?.name,
            pageSize: args?.pageSize
        });

    const { handleAsyncFilter, hasNextPage, items, noItemsText, onNextPage } =
        useSelectPanelField<SiteResponse>({
            dependency: farmId,
            dependencyRequiredText: SELECT_A_FARM_TO_SEE_FIELDS,
            fetchFn: fetchWithFarmId,
            noItemsFoundText: NO_FIELDS_FOUND,
            pageSize: DEFAULT_PAGE_SIZE,
            parseFn: parseToItems,
            resetFn: reset
        });

    return {
        fieldItems: items,
        handleAsyncFilter,
        hasNextPage,
        isLoading,
        noItemsText,
        onNextPage
    };
};

export default useData;
